/**
 * Converts a string to UPPERCASE
 *
 * @param value
 * @returns {string}
 */
export const uppercase = value => (value || value === 0) ? String(value).toUpperCase() : ''
